import { EventEmitter } from "events"

export { TRACKED_EVENTS } from "./eventBusContract"

const bus: EventEmitter = global.__bus__ ? global.__bus__ : new EventEmitter()
global.__bus__ = bus

export default bus
